import React from 'react'
import assign from 'lodash/assign'
import createReactClass from 'create-react-class'


var TranslationForm = createReactClass({

	getInitialState: function () {
		return {data: null};
	},
	componentWillReceiveProps: function (nextProps) {
		this.setState({data: assign({}, nextProps.data)});
	},
	inputChanged: function (event) {
		var data = this.state.data;
		data[event.target.name] = event.target.value;
		this.setState({data: data});
	},
  	render: function() {
  		var self = this;
  		if (this.state.data === null) {
  			return (<div></div>);
  		}

  		var json = JSON.stringify(this.state.data, null, 4);

  		var inputs = Object.keys(this.state.data).map(function(item, i) {
  			var empty = self.state.data[item].length === 0;
			return (
      			<div key={i} style={{'marginBottom': '30px'}}>
      				{item}<br/>
      				<input type="text" name={item} onChange={self.inputChanged} value={self.state.data[item]} style={{width: '900px', 'textAlign': 'left', padding: '5px', backgroundColor: (empty ? 'red' : 'white')}} />
      			</div>
      		);
		});

		return (
		  <div>
			  <form>
			  	{inputs}
			  </form>
			  <br/><br/>
			  OUTPUT (Code to send to developer):<br/>
			  <pre>{json}</pre>
		  </div>
		);
	}
});

export default TranslationForm;
